export const PRODUCT_CARD_ELEMENTS = [
    'productName',
    'ratings',
    'description',
    'pricing',
    'variantSelection',
    'addToCartButton',
    'distance',
];
export const mapProductCardConfigToFormatting = (cfg, overrides) => {
    const defaults = {
        template: 'custom',
        orientation: 'vertical',
        showBox: true,
        showImage: true,
        showTitle: true,
        showDescription: true,
        showPrice: true,
        backgroundColor: '#fff',
        addToCart: true,
        showRatings: false,
        showOriginalPrice: true,
        showVariantSelection: true,
        showAddToCartButton: true,
        showDistance: false,
        elementOrder: ['productName', 'description', 'pricing', 'variantSelection', 'addToCartButton'],
        titleMaxLines: 2,
        descriptionMaxLines: 3,
        descriptionShowSeeMore: true,
        seeMoreDetailsText: undefined,
        imageClickable: true,
        borderStyle: { borderWidth: 1, borderColor: '#ccc', borderRadius: 4 },
        maxHeight: undefined,
        maxWidth: '100%',
        horizontalWidth: 450,
        verticalWidth: 150,
        objectFit: 'contain',
        buttonStyle: {
            backgroundColor: 'color_primary',
            color: 'color_font_inverse',
            hoverBackgroundColor: 'color_primary_hover',
            hoverColor: 'color_font_inverse',
            disabledBackgroundColor: '',
            disabledColor: 'color_font',
            borderRadius: 8,
        },
        imageSwatches: {
            enabled: true,
            size: 50,
            gap: 8,
            hideOnOutOfStock: true,
        },
        preferShopifyTitle: false,
        seeMoreText: undefined,
        seeLessText: undefined,
        showCTAButton: false,
        showQuantitySelector: true,
        showCheckoutFlow: true,
    };
    const fromConfig = {
        orientation: cfg?.orientation ?? defaults.orientation,
        elementOrder: Array.isArray(cfg?.elementOrder)
            && cfg.elementOrder.length > 0
            ? cfg.elementOrder.filter((k) => {
                const allowed = PRODUCT_CARD_ELEMENTS;
                return allowed.includes(k);
            })
            : defaults.elementOrder,
        showTitle: cfg?.showTitle ?? defaults.showTitle,
        showDescription: cfg?.showDescription ?? defaults.showDescription,
        showRatings: cfg?.showRatings ?? defaults.showRatings,
        showPrice: cfg?.showPrice ?? defaults.showPrice,
        showVariantSelection: cfg?.showVariantSelection ?? defaults.showVariantSelection,
        showAddToCartButton: cfg?.showAddToCartButton ?? defaults.showAddToCartButton,
        showDistance: cfg?.showDistance ?? defaults.showDistance,
        addToCart: cfg?.addToCart ?? defaults.addToCart,
        buttonText: cfg?.buttonText ?? defaults.buttonText,
        addedToCartText: cfg?.addedToCartText ?? defaults.addedToCartText,
        loadingText: cfg?.loadingText ?? defaults.loadingText,
        soldOutText: cfg?.soldOutText ?? defaults.soldOutText,
        selectAllOptionsText: cfg?.selectAllOptionsText ?? defaults.selectAllOptionsText,
        seeMoreDetailsText: cfg?.seeMoreDetailsText ?? defaults.seeMoreDetailsText,
        checkoutText: cfg?.checkoutText ?? defaults.checkoutText,
        imageClickable: cfg?.imageClickable ?? defaults.imageClickable,
        titleMaxLines: typeof cfg?.titleMaxLines === 'number' ? cfg.titleMaxLines : defaults.titleMaxLines,
        descriptionMaxLines: typeof cfg?.descriptionMaxLines === 'number'
            ? cfg.descriptionMaxLines
            : defaults.descriptionMaxLines,
        borderStyle: cfg?.borderStyle
            ? { ...defaults.borderStyle, ...cfg.borderStyle }
            : defaults.borderStyle,
        backgroundColor: cfg?.backgroundColor ?? defaults.backgroundColor,
        maxHeight: cfg?.maxHeight ?? defaults.maxHeight,
        maxWidth: cfg?.maxWidth ?? defaults.maxWidth,
        horizontalWidth: cfg?.horizontalWidth ?? defaults.horizontalWidth,
        verticalWidth: cfg?.verticalWidth ?? defaults.verticalWidth,
        checkoutUrl: cfg?.checkoutUrl ?? '/checkout',
        objectFit: cfg?.objectFit ?? defaults.objectFit,
        buttonStyle: cfg?.buttonStyle
            ? { ...defaults.buttonStyle, ...cfg.buttonStyle }
            : defaults.buttonStyle,
        imageSwatches: cfg?.imageSwatches
            ? { ...defaults.imageSwatches, ...cfg.imageSwatches }
            : defaults.imageSwatches,
        preferShopifyTitle: cfg?.preferShopifyTitle ?? defaults.preferShopifyTitle,
        seeMoreText: cfg?.seeMoreText ?? defaults.seeMoreText,
        seeLessText: cfg?.seeLessText ?? defaults.seeLessText,
        showCTAButton: cfg?.showCTAButton ?? defaults.showCTAButton,
        showQuantitySelector: cfg?.showQuantitySelector ?? defaults.showQuantitySelector,
        showCheckoutFlow: cfg?.showCheckoutFlow ?? defaults.showCheckoutFlow,
    };
    const merged = {
        ...defaults,
        ...fromConfig,
        ...(overrides || {}),
    };
    // Ensure elementOrder remains valid after overrides
    merged.elementOrder = Array.isArray(merged.elementOrder)
        && merged.elementOrder.length > 0
        ? merged.elementOrder.filter((k) => {
            const allowed = PRODUCT_CARD_ELEMENTS;
            return allowed.includes(k);
        })
        : defaults.elementOrder;
    return merged;
};
//# sourceMappingURL=productCardConfig.js.map